import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-4" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_3 = { class: "pt-2 pl-4" }
const _hoisted_4 = { class: "pt-2 pl-4" }

import { computed } from "vue"
import accountType from "@/types/account";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextFieldsRow',
  props: {
    title: {},
    errors: {},
    labels: {},
    modelValue: {},
    itemKeys: {},
    required: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "3" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, [
            _createTextVNode(_toDisplayString(__props.title), 1),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "✴︎"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "9" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_3, _toDisplayString(__props.labels?.[0]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    class: "small pt-2",
                    modelValue: modelValue.value[__props.itemKeys[0]],
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value[__props.itemKeys[0]]) = $event)),
                    density: "compact",
                    "error-messages": props.errors[__props.itemKeys[0]]
                  }, null, 8, ["modelValue", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_4, _toDisplayString(__props.labels?.[1]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    class: "small pt-2",
                    modelValue: modelValue.value[__props.itemKeys[1]],
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value[__props.itemKeys[1]]) = $event)),
                    density: "compact",
                    "error-messages": props.errors[__props.itemKeys[1]]
                  }, null, 8, ["modelValue", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})